import { promoActive } from '../common/promo';

const allQuestions = [
  ['¿Quién puede asistir?', 'El evento es para todos los tabuladores, Equipos del Mundo y Equipos del Mundo Activo que cuenten con su boleto. El cupo máximo es de 140 personas.'],
  ['¿Hay descuento por varios boletos?', 'Hasta el 31 de octubre, 6 boletos cuestan $800 ($133 por persona) en lugar de $900 si los compras por separado.'],
  ['¿Cómo recibo mi boleto?', 'Al completar tu pago recibes la confirmación por correo; preséntala el día del evento.'],
  ['¿Qué es la cena de calificación?', 'Una cena el sábado para quienes alcanzan 5,000 PVT en octubre, previo registro.']
];

export default function FAQ() {
  const questions = allQuestions.filter(([q]) => promoActive() || !q.includes('descuento'));
  return (
    <section className="section faq-section" id="preguntas">
      <div className="container faq-layout">
        <div className="faq-heading"><span className="eyebrow">06 / INFORMACIÓN ÚTIL</span><h2>Antes de<br /><span>encontrarnos.</span></h2><p>Todo lo que necesitas saber antes de asegurar tu lugar.</p><div className="faq-contact">¿Tienes dudas? <a href="https://wa.me/525632840999" target="_blank" rel="noopener noreferrer">Escríbenos por WhatsApp al 56 3284 0999 ↗</a></div></div>
        <div className="faq-list">
          {questions.map(([question, answer], index) => (
            <details className="faq-item" key={question}>
              <summary><span className="faq-num">0{index + 1}</span><span>{question}</span><span className="faq-plus">+</span></summary>
              <p>{answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}